// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_DDb","top":"styles_top__2zfkh","left":"styles_left__1dpLj","description":"styles_description__1sJcj"};